import { useState } from "react";

const CopyCommandBtn = ({ code }) => {
  const [copied, setCopied] = useState(false);
  const command = `/link ${code}`;
  return (
    <button
      onClick={() => { navigator.clipboard.writeText(command); setCopied(true); setTimeout(() => setCopied(false), 2000); }}
      style={{
        display: "flex", alignItems: "center", gap: 10, width: "100%",
        padding: "12px 16px", background: copied ? "rgba(74,158,106,0.08)" : "rgba(0,212,170,0.06)",
        border: `1px solid ${copied ? "var(--green)" : "var(--accent)"}`, borderRadius: "var(--radius)",
        cursor: "pointer", transition: "all 0.15s",
      }}
    >
      <span style={{ fontFamily: "var(--font-mono)", fontSize: "15px", fontWeight: 600, color: "var(--text)", letterSpacing: "0.04em" }}>{command}</span>
      <span style={{ marginLeft: "auto", fontFamily: "var(--font-mono)", fontSize: "10px", color: copied ? "var(--green)" : "var(--accent)", letterSpacing: "0.08em" }}>
        {copied ? "✓ COPIED — PASTE IN BOT" : "TAP TO COPY"}
      </span>
    </button>
  );
};

export default CopyCommandBtn;
